/*
 * Giveaway Gator cart entry total.
 *
 * Shows a cart-wide "Your Entries" total in the cart drawer and cart page.
 *
 * The number comes from GG's authoritative order-time calculation via the
 * app-proxy endpoint POST <appPrefix>/api/entries/calculate (same calc path the
 * order webhook uses). Unlike summing the per-line .gg-entry-total tags, this
 * accounts for discount-code bonuses, order-value thresholds, and multiplier
 * products in the cart. See docs/cart-entry-total-endpoint.md.
 *
 * The cart re-renders on every quantity change and GG fills tags async, so we
 * recompute on a debounced MutationObserver over the cart containers.
 */
(function () {
  var OBSERVE_ROOTS = ['#mini-cart', '[data-gg-cart-root]'];

  // Derive the app-proxy prefix from the embed script (dev/prod slugs differ).
  function ggAppPath() {
    var s = document.querySelector('script[src*="/embeds/promo"]');
    var m = s && (s.getAttribute('src') || '').match(/\/apps\/([^/]+)\/embeds\/promo/);
    return m ? '/apps/' + m[1] : '/apps/giveaway-gator';
  }

  // Only write when the value actually changes, so our own renders never feed
  // the MutationObserver back into another recompute.
  function render(total) {
    document.querySelectorAll('[data-gg-cart-total]').forEach(function (el) {
      var valueEl = el.querySelector('.gg-cart-total-value') || el;
      var text = total.toLocaleString();
      if (valueEl.textContent !== text) valueEl.textContent = text;
      var hide = total <= 0;
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  // The calculate endpoint only needs to run when the cart contents change —
  // fingerprint the cart and reuse the last total for pure re-renders.
  var lastFingerprint = null;
  var lastTotal = null;
  function fingerprint(cart) {
    return cart.items
      .map(function (it) { return it.variant_id + 'x' + it.quantity + '@' + it.final_price; })
      .concat((cart.cart_level_discount_applications || []).map(function (d) { return d.title || d.code; }))
      .join('|') + '#' + cart.total_price;
  }

  var seq = 0;
  function recompute() {
    var cfg = (window.GiveawayGator || {}).config || {};
    if (!cfg.shop) return;
    var mySeq = ++seq;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fp = fingerprint(cart);
        if (fp === lastFingerprint && lastTotal !== null) {
          if (mySeq === seq) render(lastTotal);
          return null;
        }
        var body = {
          shop: cfg.shop,
          totalPrice: cart.total_price / 100, // Shopify cart prices are in cents
          discountCodes: (cart.cart_level_discount_applications || [])
            .map(function (d) { return d.title || d.code; })
            .filter(Boolean),
          tags: [],
          lineItems: cart.items.map(function (it) {
            return {
              productId: String(it.product_id),
              variantId: String(it.variant_id),
              quantity: it.quantity,
              price: it.final_price / 100, // per-unit, cents -> dollars
              title: it.product_title || it.title,
            };
          }),
        };
        return fetch(ggAppPath() + '/api/entries/calculate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (mySeq !== seq) return; // a newer request superseded this one
            var total = (data.promotions || []).reduce(function (s, p) {
              return s + (p.totalEntries || 0);
            }, 0);
            lastFingerprint = fp;
            lastTotal = total;
            render(total);
          });
      })
      .catch(function () { /* leave the last good value; don't blank the row */ });
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(recompute, 150);
  }

  // Skip mutations caused by GG display elements (our total row, per-line entry
  // tags) — those are outputs, not cart changes.
  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || !el.closest('[data-gg-cart-total], [data-gg-entry-tag]')) {
        schedule();
        return;
      }
    }
  }

  function init() {
    OBSERVE_ROOTS.forEach(function (sel) {
      var root = document.querySelector(sel);
      if (root) {
        new MutationObserver(onMutations).observe(root, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    });
    recompute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
